'use client'

import { PropsWithChildren, useEffect } from 'react';
import MenuProfile from '../Components/Layout/MenuProfile';
import { useStoreHook } from '../Hooks/StoreHook';
import { useNavigate } from 'react-router-dom';
import { useLoginContext } from '../Contexts/LoginContext';
import { useLayoutContext } from '../Contexts/LayoutContext';

const DefaultLayoutProfile = ({
  children,
}: PropsWithChildren) => {

  const { company } = useLayoutContext();
  const { getLinkToHome, loadCompanyInfo } = useStoreHook();
  const { isAuthenticated } = useLoginContext();

  const navigate = useNavigate();

  useEffect(() => {
      if (!isAuthenticated) {
          navigate(getLinkToHome());
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useEffect(() => {
      if (!company) {
          loadCompanyInfo()
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col md:flex-row gap-x-4 gap-y-2">
      <section className="flex flex-col max-h-max w-full md:max-w-max rounded-xl p-2 px-4 md:bg-gray-50">
          <MenuProfile />
      </section>
      <section className="w-full p-0 rounded-xl">
        { children }
      </section>
  </div>
  )
}

export default DefaultLayoutProfile;